// extracted by mini-css-extract-plugin
export var actionButton = "_ym-2";
export var card = "_ym-0";
export var disambiguationList = "_ym-3";
export var errorCard = "_ym-4";
export var row = "_ym-1";